import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ModalContainer from '../../modal-container'
import Button from '../../button'
import styles from './confirmation-modal.css'

function ConfirmationModal({
  header,
  message,
  confirmText,
  cancelText,
  onConfirmClick,
  onCancelClick,
  customWrapperClass
}) {
  const hasCancelButton = (cancelText !== '')

  return (
    <ModalContainer onRequestClose={onCancelClick}>
      <div className={classNames(styles.confirmationWrapper, customWrapperClass)}>
        <div className={styles.header}>
          <h1 className={styles.title}>{header}</h1>
          {
            message && (
              <span className={styles.subHeader}>
                {message}
              </span>
            )
          }
        </div>
        <div className={styles.buttonsWrapper}>
          <Button
            onClick={onConfirmClick}
            className={
              classNames(
                styles.confirmButton,
                {
                  [styles.large]: !hasCancelButton
                }
              )
            }
            text={confirmText}
            lightBGPrimary
          />
          {
            hasCancelButton && (
              <Button
                onClick={onCancelClick}
                className={styles.cancelButton}
                text={cancelText}
                secondary
              />
            )
          }
        </div>
      </div>
    </ModalContainer>
  )
}

ConfirmationModal.propTypes = {
  header: PropTypes.string.isRequired,
  message: PropTypes.string,
  confirmText: PropTypes.string.isRequired,
  cancelText: PropTypes.string,
  onConfirmClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func,
  customWrapperClass: PropTypes.string
}

ConfirmationModal.defaultProps = {
  message: '',
  cancelText: '',
  onCancelClick: null,
  customWrapperClass: ''
}

export default ConfirmationModal
